import type {GpsSource} from "@/src/modules/core/types/geolocation";

export enum BreakAction {
  START = "start",
  COMPLETE = "complete",
  DELAY = "delay",
  INTERRUPT = "interrupt",
  REJECT = "reject",
  TAKEN = "taken",
}

export type ShiftStartRequest = {
  shift_id: number;
  gps_coordinates: string;
  gps_source?: GpsSource;
  date?: string;
  time?: string;
  officer_teams_and_conditions_acknowledged?: number;
};

/** Body returned by `POST shift/start` (under top-level `data` when the API uses an envelope). */
export type ShiftStartResponseData = {
  shift_id: number;
  worked_shift_id?: number;
  status?: string;
  actual_start_datetime?: string;
  message?: string;
  worked_shift?: unknown;
};

export type ShiftEndRequest = {
  shift_id: number;
  gps_coordinates: string;
  gps_source?: GpsSource;
};

/** Body returned by `POST shift/end` (under top-level `data` when the API uses an envelope). */
export type ShiftEndResponseData = {
  shift_id: number;
  worked_shift_id?: number;
  status?: string;
  tokens_revoked: boolean;
};

export type BreakActionRequest = {
  shift_break_id: number;
  gps_coordinates: string;
  gps_source?: GpsSource;
  action: BreakAction;
  delay_minutes?: number;
  reason?: string;
};

export type ExtendShiftRequest = {
  shift_id: number;
  extension_minutes: number;
};
